import React, { useState, useCallback } from 'react';
import { Button, Input } from '@cloudscape-design/components';
import { InputProps } from '@cloudscape-design/components/input';
import { NonCancelableCustomEvent } from '@cloudscape-design/components';
import { useCopilot } from './CopilotContext';
import './Copilot.css';

export function CopilotMessageInput() {
  const { state, sendMessage } = useCopilot();
  const [inputValue, setInputValue] = useState('');

  const handleSend = useCallback(() => {
    if (inputValue.trim() && !state.isLoading) {
      sendMessage(inputValue);
      setInputValue('');
    }
  }, [inputValue, state.isLoading, sendMessage]);

  const handleKeyDown = useCallback(
    (event: NonCancelableCustomEvent<InputProps.KeyDetail>) => {
      if (event.detail.key === 'Enter' && !event.detail.shiftKey) {
        handleSend();
      }
    },
    [handleSend],
  );

  return (
    <div className="copilot-input-row">
      <div className="copilot-input-field">
        <Input
          value={inputValue}
          onChange={({ detail }) => setInputValue(detail.value)}
          onKeyDown={handleKeyDown}
          placeholder="Ask about audits, tasks, questions..."
          disabled={state.isLoading}
          autoFocus
        />
      </div>
      <Button
        variant="primary"
        iconName="send"
        onClick={handleSend}
        disabled={state.isLoading || !inputValue.trim()}
        ariaLabel="Send message"
      />
    </div>
  );
}
